module.exports = __webpack_public_path__ + "img/car (1).5b7dea46.png";